import "./ExpressVpnVsNordVpn.module.css";
import Header from "@/reusable_sections/Header";
import Herocomparison from "./sections/Herocomparison";
import Comparison from "./sections/Comparison";
import Relatedvpnarticles from "./sections/Relatedvpnarticles";
import Footer from "@/reusable_sections/Footer";
export default function ExpressVpnVsNordVpnPage() {
  return <div>
      <Header />
      <Herocomparison />
      <Comparison />
      <Relatedvpnarticles />
      <Footer />
    </div>;
}